/*
 * fn: mergeRefs
 *
 * Merges multiple refs into a single ref callback
 *
 */
import { type Ref, type RefCallback } from 'react'

export const mergeRefs =
  <T>(...refs: (Ref<T> | undefined)[]): RefCallback<T> =>
  (node: T | null) => {
    for (const ref of refs) {
      if (typeof ref === 'function') ref(node)
      else if (ref) (ref as { current: T | null }).current = node
    }
  }
